// extracted by mini-css-extract-plugin
module.exports = {"desktop":"toolbar_desktop__3wUEd","mobile":"toolbar_mobile__1m38T","primary":"toolbar_primary__1Ravm"};